(function () {
  'use strict';

  var ROOT = document.documentElement;
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SESSION_KEY = 'taupe-page-seen';
  var overlay = null;

  function getOverlay() {
    if (!overlay) {
      overlay = document.getElementById('taupe-page-transition');
    }
    return overlay;
  }

  function hideOverlay() {
    var node = getOverlay();
    if (!node) return;
    node.setAttribute('aria-hidden', 'true');
  }

  function finishInitialLoad() {
    ROOT.classList.remove('taupe-is-loading');
    ROOT.classList.remove('taupe-page-entering');
    ROOT.classList.add('taupe-page-ready');
    hideOverlay();
  }

  function runInitialPreloader() {
    if (REDUCED_MOTION.matches || (window.Shopify && Shopify.designMode)) {
      finishInitialLoad();
      return;
    }

    var seen = sessionStorage.getItem(SESSION_KEY) === '1';
    var minDuration = seen ? 320 : 780;
    var started = Date.now();

    function complete() {
      var elapsed = Date.now() - started;
      var wait = Math.max(0, minDuration - elapsed);
      window.setTimeout(function () {
        sessionStorage.setItem(SESSION_KEY, '1');
        finishInitialLoad();
      }, wait);
    }

    if (document.readyState === 'complete') {
      complete();
    } else {
      window.addEventListener('load', complete, { once: true });
    }
  }

  runInitialPreloader();
})();
